import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { forwardRef } from "react";
import { cn } from "../../lib/utils";

export const Avatar = forwardRef<HTMLSpanElement, AvatarPrimitive.AvatarProps>(function Avatar(
  { className, ...props },
  ref,
) {
  return (
    <AvatarPrimitive.Root
      ref={ref}
      className={cn(
        "relative flex h-8 w-8 shrink-0 overflow-hidden rounded-full bg-(--accent-500) text-white text-xs font-semibold items-center justify-center",
        className,
      )}
      {...props}
    />
  );
});

export const AvatarImage = forwardRef<HTMLImageElement, AvatarPrimitive.AvatarImageProps>(
  function AvatarImage({ className, ...props }, ref) {
    return (
      <AvatarPrimitive.Image
        ref={ref}
        className={cn("aspect-square h-full w-full", className)}
        {...props}
      />
    );
  },
);

export const AvatarFallback = forwardRef<HTMLSpanElement, AvatarPrimitive.AvatarFallbackProps>(
  function AvatarFallback({ className, ...props }, ref) {
    return (
      <AvatarPrimitive.Fallback
        ref={ref}
        className={cn("flex h-full w-full items-center justify-center", className)}
        {...props}
      />
    );
  },
);
